import { Crosshair, Minus, Plus } from "lucide-react";
import React from "react";
import { IconButton } from "../../../ui/IconButton";
import { TooltipProvider } from "../../../ui/tooltip";
import { useMapCanvasStage } from "../../contexts/MapCanvasContext";
import { getWindowKonvaObject } from "../../helpers/konva/getWindowKonvaObject";
import { useZoomStageToScale } from "../../helpers/useZoomStageToScale";

/**
 * Floating zoom controls in the bottom-right corner of the canvas:
 * zoom out / current scale / zoom in / center stage.
 */
export const EditorZoomPill: React.FC = () => {
  const { stageScale, centerStage } = useMapCanvasStage();
  const handleZoom = useZoomStageToScale();

  const handleZoomIn = () => {
    const newScale = Math.min(stageScale * 1.2, 5);
    handleZoom(getWindowKonvaObject().stages[0], newScale, true);
  };

  const handleZoomOut = () => {
    const newScale = Math.max(stageScale / 1.2, 0.1);
    handleZoom(getWindowKonvaObject().stages[0], newScale, true);
  };

  const percentage = Math.round(stageScale * 100);

  return (
    <TooltipProvider delayDuration={150}>
      <div className="absolute right-4 bottom-5 z-sticky flex items-center gap-0.5 rounded-lg border border-neutral-200 bg-background-primary p-1 shadow-lg">
        <IconButton
          label="Zoom out"
          onClick={handleZoomOut}
          disabled={stageScale <= 0.1}
        >
          <Minus size={16} />
        </IconButton>
        <span className="min-w-11 flex-none text-center font-semibold text-[11.5px] text-neutral-600 [font-variant-numeric:tabular-nums]">
          {percentage}%
        </span>
        <IconButton
          label="Zoom in"
          onClick={handleZoomIn}
          disabled={stageScale >= 5}
        >
          <Plus size={16} />
        </IconButton>
        <div className="mx-0.5 h-4 w-px flex-none bg-neutral-200" />
        <IconButton label="Center map" onClick={centerStage}>
          <Crosshair size={16} />
        </IconButton>
      </div>
    </TooltipProvider>
  );
};
